module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard@2x-77b32391383d3d10dad71e7f655afdec.png";